import { AssetAllocation } from '../components/report/AssetAllocation';
import { AssetClassPerformance } from '../components/report/AssetClassPerformance';
import { CashTransactions } from '../components/report/CashTransactions';
import { ContributionsAndWithdrawals } from '../components/report/ContributionsAndWithdrawals';
import { CurrencyExposure } from '../components/report/CurrencyExposure';
import { Expenses } from '../components/report/Expenses';
import { HoldingsVsTargetVariance } from '../components/report/HoldingsVsTargetVariance';
import { IncomeReport } from '../components/report/IncomeReport';
import { IncomeReceived } from '../components/report/IncomeReceived';
import { InvestmentIncomeTax } from '../components/report/InvestmentIncomeTax';
import { PorfolioPerformance } from '../components/report/PortfolioPerformance';
import { PortfolioSnapshot } from '../components/report/PortfolioSnapshot';
import { PortfolioValuation } from '../components/report/PortfolioValuation';
import { PortfolioValuationCondensed } from '../components/report/PortfolioValuationCondensed';
import { ProjectedIncomeCashflow } from '../components/report/ProjectedIncomeCashflow';
import { RealisedCapitalGainsAndLosses } from '../components/report/RealisedCapitalGainsAndLosses';
import { SecurityContribution } from '../components/report/SecurityContribution';
import { SecurityPerformance } from '../components/report/SecurityPerformance';
import { TaxInvoice } from '../components/report/TaxInvoice';
import { TaxSummary } from '../components/report/TaxSummary';
import { TransactionHistory } from '../components/report/TransactionHistory';
import { UnrealisedCapitalGainsAndLosses } from '../components/report/UnrealisedCapitalGainsAndLosses';
import { UnrealisedNonCGTGainsAndLosses } from '../components/report/UnrealisedNonCGTGainsAndLosses';
import { UXChangeTaxStatementReport } from '../components/report/UXChangeTaxStatementReport';
import { ReportComponentConfig, ReportFormat } from './types';

export const ReportingComponentListOptions: ReportComponentConfig[] = [
  {
    component: AssetAllocation,
  },
  {
    component: AssetClassPerformance,
  },
  {
    component: CashTransactions,
  },
  {
    component: ContributionsAndWithdrawals,
  },
  {
    component: CurrencyExposure,
  },
  {
    component: Expenses,
  },
  {
    excelFeatureFlagged: true,
    component: HoldingsVsTargetVariance,
  },
  {
    component: IncomeReceived,
  },
  {
    component: IncomeReport,
  },
  {
    component: InvestmentIncomeTax,
  },
  {
    component: PorfolioPerformance,
  },
  {
    component: PortfolioSnapshot,
  },
  {
    component: PortfolioValuationCondensed,
  },
  {
    component: PortfolioValuation,
  },
  {
    excelFeatureFlagged: true,
    component: ProjectedIncomeCashflow,
  },
  {
    component: RealisedCapitalGainsAndLosses,
  },
  {
    component: SecurityContribution,
    excelFeatureFlagged: true,
  },
  {
    component: SecurityPerformance,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: TaxInvoice,
  },
  {
    nonSuperOnly: true,
    component: TaxSummary,
  },
  {
    component: TransactionHistory,
  },
  {
    component: UnrealisedCapitalGainsAndLosses,
  },
  {
    component: UnrealisedNonCGTGainsAndLosses,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.Excel, ReportFormat.JSON],
    isAdminOnly: true,
    component: UXChangeTaxStatementReport,
  },
];
